// src/app/theme.ts
import { extendTheme } from "@chakra-ui/react";

const colors = {
  primary: {
    50: "#e6f2ff",
    100: "#cce6ff",
    200: "#99ccff",
    300: "#66b3ff",
    400: "#3399ff",
    500: "#0042BA", // primary
    600: "#005ec0",
    700: "#004899",
    800: "#003366",
    900: "#001a33",
  },
};

const focusRing = {
  _focus: {
    borderColor: "primary.500",
    boxShadow: "0 0 0 1px var(--chakra-colors-primary-500)",
  },
};

const theme = extendTheme({
  colors,
  fonts: {
    heading:
      "Work Sans, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif",
    body: "Work Sans, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif",
  },
  components: {
    Button: {
      baseStyle: { borderRadius: "md" },
      defaultProps: { colorScheme: "brand" },
    },
    Input: {
      variants: {
        outline: {
          field: focusRing,
        },
      },
    },
    Select: {
      variants: {
        outline: {
          field: focusRing,
        },
      },
    },
    Textarea: {
      variants: {
        outline: focusRing,
      },
    },
    Spinner: {
      defaultProps: { color: "primary.500" },
    },
    Checkbox: {
      defaultProps: { colorScheme: "primary" },
    },
    Radio: {
      defaultProps: { colorScheme: "primary" },
    },
    Switch: {
      defaultProps: { colorScheme: "primary" },
    },
  },
});

export default theme;
